import Axios from 'axios'
import publicIp from 'public-ip'
import { store } from '../store'
import Config from 'custom/config/environment'

import { SET_SERVICE_LOADER, SET_AUTH_TOKEN } from '../store/constants'
import NotificationService from './notification.service'
let apiErrorCount = 0

const axios = Axios.create({
  baseURL: Config.SERVICE_URL,
})

axios.interceptors.request.use(
  async (config) => {
    const { auth, app } = store.getState()
    const interceptedConfig = config
    interceptedConfig.headers['Content-type'] = 'application/json'
    interceptedConfig.headers['Accept-Language'] = app.language

    if (auth.authToken !== null) {
      interceptedConfig.headers.Authorization = `Bearer ${auth.authToken}`
    }
    if (
      interceptedConfig.method.toUpperCase() === 'GET' &&
      !interceptedConfig.url.endsWith('/login')
    ) {
      // interceptedConfig.params.language = 'en'
      interceptedConfig.params.language = app.language
      interceptedConfig.params.ipAddress = '0.0.0.0' //await publicIp.v4();
      interceptedConfig.params.channelType = 'CORPWEB'
      if (Object.keys(app?.loginDetails).length > 0) {
        interceptedConfig.params.userName = app?.loginDetails?.userName
      }
      interceptedConfig.params.customerId = '123'
      interceptedConfig.params.userGroup = app?.userDetails.groupId || app?.loginDetails?.groupId
      interceptedConfig.params.mode = app?.roleAccessKey || 'I'
    }
    if (
      interceptedConfig.method.toUpperCase() === 'POST' &&
      !interceptedConfig.url.endsWith('/login') &&
      !interceptedConfig.url.endsWith('/fileUpload/initVerify') &&
      !interceptedConfig.url.endsWith('/fileUpload/initConfirm') &&
      !interceptedConfig.url.endsWith('/fundTransfer/invoiceUpload')
    ) {
      interceptedConfig.data.language = app.language
      // interceptedConfig.data.language = 'en'
      interceptedConfig.data.ipAddress = '0.0.0.0' //await publicIp.v4();
      interceptedConfig.data.channelType = 'CORPWEB'
      if (Object.keys(app?.loginDetails).length > 0) {
        interceptedConfig.data.userName = app?.loginDetails?.userName
      }
      if (!interceptedConfig.url.endsWith('/chequeBook/initVerify') &&
        !interceptedConfig.url.endsWith('/chequeBook/initConfirm')) {
        interceptedConfig.data.customerId = '123'
      }
      interceptedConfig.data.userGroup =
        app?.loginDetails?.groupId || app?.userDetails?.groupId || 0
      interceptedConfig.data.mode = app?.roleAccessKey || 'I'
    }

    if (
      (interceptedConfig.method.toUpperCase() === 'POST' &&
        interceptedConfig.url.endsWith('/fileUpload/initVerify')) ||
      interceptedConfig.url.endsWith('/fileUpload/initConfirm') ||
      interceptedConfig.url.endsWith('/fundTransfer/invoiceUpload')
    ) {
      // interceptedConfig.data.append('language', 'en')
      interceptedConfig.data.append('language', app.language)
      interceptedConfig.data.append('ipAddress', '0.0.0.0')
      interceptedConfig.data.append('channelType', 'CORPWEB')
      interceptedConfig.data.append('customerId', '123')
      if (Object.keys(app?.loginDetails).length > 0) {
        interceptedConfig.data.append('userName', app?.loginDetails?.userName)
        // interceptedConfig.data.userName = app?.loginDetails?.userName;
      }
      interceptedConfig.data.append(
        'userGroup',
        app?.loginDetails?.groupId || app?.userDetails?.groupId || 0,
      )
      interceptedConfig.data.append('mode', app?.roleAccessKey || 'I')
    }

    if (interceptedConfig.url.endsWith('/access/terms')) {
      interceptedConfig.data.channelType = 'INTERNET'
    }
    return interceptedConfig
  },
  (error) => Promise.reject(error),
)

axios.interceptors.response.use(
  (response) => {
    apiErrorCount = 0
    try {
      if (response.headers.authorization) {
        store.dispatch({
          type: SET_AUTH_TOKEN,
          payload: response.headers.authorization || null,
        })
      }
      return response
    } catch (err) {
      console.error(err)
      return response
    }
  },
  async (error) => {
    if (error.response) {
      if (error.response.status === 403) {
        if (apiErrorCount === 0) {
          ++apiErrorCount
          NotificationService.showErrorMessage(
            error?.response?.data?.message || 'Session timeout. Please try again',
          )
          store.dispatch({ type: 'USER_LOGOUT' })
        }
      } else {
        store.dispatch({ type: 'SET_ERROR_MESSAGE', payload: error?.response })
      }
    } else {
      store.dispatch({
        type: SET_ERROR_MESSAGE,
        payload: {
          code: 'Network Error',
          message: 'It may server down.Please contact to Admin',
          errors: null,
        },
      })

      store.dispatch({ type: 'USER_LOGOUT' })
      // NotificationService.showErrorMessage('It may server down.Please contact to Admin')
    }
    return Promise.reject(error.response || error.request || error.message)
  },
)

export default axios
